import { Component, ErrorInfo, ReactNode } from "react";
import { Button } from "./ui/button";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class GlobalErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center bg-background">
          <h1 className="text-2xl font-bold text-destructive mb-4">Qualcosa è andato storto 😕</h1>
          <p className="text-muted-foreground mb-4 max-w-md">
            Si è verificato un errore imprevisto. Prova a ricaricare la pagina.
          </p>
          <div className="bg-muted p-4 rounded-md text-left text-xs font-mono mb-6 max-w-lg overflow-auto w-full">
            {this.state.error?.toString()}
          </div>
          <Button onClick={() => window.location.reload()}>
            Ricarica Pagina
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
